import WPCard from "./WPCard"
export default WPCard;
